import axios from "axios";
import { supabase } from "./supabase";
import { visitorIdInterceptor } from "./api";

const apiWithAuth = axios.create({
   baseURL: process.env.REACT_APP_API_URL,
   headers: {
      "Content-Type": "application/json",
   },
});

apiWithAuth.interceptors.request.use(visitorIdInterceptor);

apiWithAuth.interceptors.request.use(
   async (config) => {
      try {
         const {
            data: { session },
         } = await supabase.auth.getSession();

         if (session?.access_token) {
            config.headers["X-Session-Token"] = session.access_token;
            config.headers["X-User-ID"] = session.user.id;
         }

         return config;
      } catch (error) {
         console.error("Error adding auth token:", error);
         return config;
      }
   },
   (error) => {
      return Promise.reject(error);
   }
);

apiWithAuth.interceptors.response.use(
   (response) => response,
   async (error) => {
      const originalRequest = error.config;

      if (originalRequest && !originalRequest._retryCount) {
         originalRequest._retryCount = 0;
      }

      const MAX_RETRY_ATTEMPTS = 1;

      if (error.response?.status === 401 && originalRequest._retryCount < MAX_RETRY_ATTEMPTS) {
         originalRequest._retryCount += 1;
         originalRequest._retry = true;

         try {
            const { data, error: refreshError } = await supabase.auth.refreshSession();

            if (refreshError) {
               console.error("❌ Token refresh failed:", refreshError);
               await supabase.auth.signOut();
               return Promise.reject(error);
            }

            if (data.session?.access_token) {
               console.log("✅ Token refreshed, retrying request...");
               originalRequest.headers["X-Session-Token"] = data.session.access_token;
               originalRequest.headers["X-User-ID"] = data.session.user.id;

               return apiWithAuth(originalRequest);
            }
         } catch (refreshError) {
            console.error("❌ Token refresh error:", refreshError);
            await supabase.auth.signOut();
         }
      }

      // IMPORTANT: Always reject the error if we're not handling it
      return Promise.reject(error);
   }
);

export default apiWithAuth;
